import { SelectOption } from 'components/inputs/BaseSelect';
import { css } from 'emotion';
import chevronDown from 'images/icons/chevron-down-16.svg';
import snakeCase from 'lodash/snakeCase';
import React, { CSSProperties } from 'react';
import Select, { MenuPlacement, Styles } from 'react-select';
import { ActionMeta, ValueType } from 'react-select/src/types';

interface Props {
  id: string;
  isMulti: boolean;
  value?: SelectOption | SelectOption[] | null | undefined;
  className?: string;
  options: SelectOption[];
  menuPlacement: MenuPlacement;
  onChange: (
    selectOptions: ValueType<SelectOption, boolean>,
    actionsMeta: ActionMeta<SelectOption>
  ) => void;
  defaultValue?: ValueType<SelectOption, boolean>;
  components?: any;
  isDisabled?: boolean;
  isSearchable?: boolean;
}

const customStyles: Styles<SelectOption, boolean> = {
  control: (provided, state) => {
    return {
      ...provided,
      minHeight: '32px',
      height: '32px',
      borderColor: '#d1d5de',
      borderRadius: '8px',
      backgroundColor: state.isDisabled
        ? 'var(--mid-grey-1)'
        : provided.backgroundColor || '#ffffff',
      cursor: state.isDisabled ? 'not-allowed' : 'inherit',
    };
  },
  placeholder: (provided) => {
    return {
      ...provided,
      fontWeight: 300,
      fontSize: '14px',
      color: 'var(--black-1)',
    };
  },
  valueContainer: (provided) => {
    return {
      ...provided,
      fontWeight: 300,
    };
  },
  indicatorsContainer: (provided) => {
    return {
      ...provided,
      padding: 0,
    };
  },
  indicatorSeparator: () => ({
    display: 'none',
  }),
};

class ShortDropdown extends React.Component<Props> {
  render(): React.ReactNode {
    const { id } = this.props;

    return (
      <Select
        styles={customStyles}
        components={{
          Option: ({ children, getStyles, innerRef, ...props }) => {
            // NOTE: the use of emotion directly below is required by react-select to do custom styling.
            //       This is an exception to normal styling policies. Emotion should not be used elsewhere.
            const cn = css(getStyles('option', props));
            const val = snakeCase(props.data.value);

            return (
              <div
                ref={innerRef}
                {...props.innerProps}
                className={`light ${cn} ${id}-option ${id}-option-${val}`}
              >
                {children}
              </div>
            );
          },
          IndicatorsContainer: () => {
            return (
              <div id={`${id}-down-chevron`} className="px2">
                <img src={chevronDown} alt="short" />
              </div>
            );
          },
        }}
        {...this.props}
        menuPlacement={this.props.menuPlacement}
      />
    );
  }
}

export default ShortDropdown;
